import { useRouteError } from 'react-router-dom';

import { ErrorAlert } from '@/components/primitives/error-alert';
import { getErrorMessage } from '@/lib/errors';

export function ErrorBoundary() {
  const error = useRouteError();
  return (
    <ErrorAlert
      title="Errore inatteso"
      message={getErrorMessage(error)}
      action={() => window.location.reload()}
    />
  );
}
